import axios from 'axios';

export class ExtensionAdminService {
    getProrrogaAdmin(
        lender,
        borrower) {
        return axios.get('/appapv/getProrrogaAdmin.action', {
            params: {
                idInstitucionPrestamista: lender.idInstitucion,
                idInstitucionPrestatario: borrower.idInstitucion,
            }
        }).then(res => res.data.payload[0]);
    }

    rejectExtension(
        loanId,
        status) {
        return axios.post('/appapv/rejectExtension.action', {}, {
            params: {
                folio: loanId,
                status: status,
            }
        }).then(res => res.data);
    }

    confirmExtension(
        loanId,
        status) {
        return axios.post('/appapv/confirmExtension.action', {}, {
            params: {
                folio: loanId,
                status: status,
            }
        }).then(res => res.data);
    }

    insertExtensionAdmin(
        loanId,
        maturity,
        status,
        rate,
        surcharge) {
        return axios.post('/appapv/insertExtensionAdmin.action', {}, {
            params: {
                folio: loanId,
                status: status,
                plazo: maturity,
                tasa: rate,
                sobreTasa: surcharge,
            }
        }).then(res => res.data);
    }
}